import { useTranslation } from "react-i18next";
import { useCurrency } from "@/lib/currency";
import { priceUnitLabel, type CardFacts } from "@/lib/catalog-presentation";

export function TourPriceContext({ tour }: { tour: CardFacts }) {
  const { i18n } = useTranslation();
  const { currency } = useCurrency();
  return <span className="block text-[10px] font-medium leading-snug text-muted-foreground">{currency} · {priceUnitLabel(tour, i18n.language)}</span>;
}